import LoginSignUpContainer from 'containers/LoginSignUpContainer';
import React from 'react';

const CSS = require('./LoggedOut.module.scss');

interface LoggedOutProps {
  title: string;
}

function LoggedOut({ title }: LoggedOutProps) {
  return (
    <div className={CSS.LoggedOut}>
      <h1 className={CSS.Title}>{title}</h1>
      <LoginSignUpContainer />
    </div>
  );
}

export default LoggedOut;
